const initialState = {
  kpiFormList: {},
  achievementSummary: {}
}

const achievement = (state = initialState, action) => {
  switch (action.type) {
    case "SET_KPI_FORM_LIST":
      state.kpiFormList = action.payload;
      return state;
    case "SET_ACHIEVEMENT_SUMMARY":
        state.achievementSummary = action.payload;
        return state;
    default:
      return state;
  }
};

export default achievement;
